





























































































































































import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import store, { RootStoreState } from '@/store';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import SwCustomSelect from './components/sw-custom-select.vue';
import navItems from '@/core/nav-service/nav-data';
import SwRmApiMixin from '../sw-rm-api-mixin/sw-rm-api-mixin.vue';
import { NavNode } from '@/core/nav-service/types';
import { CreateElement, VNode } from 'vue';
import { tooltip, TooltipDirValues } from '@libs/unified-ui-framework/src/shared/tooltip-dir';
import { SwDiscreetProgress, SwStickProgress } from '@libs/unified-ui-framework/src/shared/sw-progress';
import { SwIconButton } from '@libs/unified-ui-framework/src/shared/sw-icon-button';
import { popover, PopoverDirValues } from '@libs/unified-ui-framework/src/shared/popover-dir';
import SwFtrRiskMeterPopover from './components/sw-risk-meter-popover.vue';
import { CoreStoreState } from '../core.store';
import IconEndpoint from './../../assets/RM_Logo.svg';

@Component({
  components: {
    SwIcon,
    SwDiscreetProgress,
    SwStickProgress,
    SwCustomSelect,
    SwIconButton,
    SwFtrRiskMeterPopover,
  },
  directives: {
    tooltip,
    popover,
  },
})
export default class SwAppTitle extends mixins(SwRmApiMixin) {
  hardReset() {
    store.commit('setBillmeterloading', { billmeterloading: true });
    store.commit('setBmResetAllowed', { bmResetAllowed: false });
    this.processApi(true, (this.resetTenantId));
    this.isClickPopoverVisible = false;
    this.doNotShow = true;
  }

  onSelectTenant() {
    this.isClickPopoverVisible = false;
    this.doNotShow = true;
  }

  resetTenantId() {
    if (!this.bmResetAllowed) {
      return;
    }
    const internalSelectedTenantId = this.internalSelectedTenantId;
    this.internalSelectedTenantId = '';
    this.$nextTick(() => { this.internalSelectedTenantId = internalSelectedTenantId; });
  }

  navItems: NavNode[] = navItems;
  isClickPopoverVisible: boolean = false;
  isClickPopoverVisible1: boolean = true;
  doNotShow: boolean = true;
  cssPrefix: String = 'sw-app-title';
  iconEndpointImg = IconEndpoint;
  colorArray = [{ color: '#97CC2D', value: 5 },
    { color: '#EDE385', value: 4 },
    { color: '#FDCB2E', value: 3 },
    { color: '#FD9721', value: 2 },
    { color: '#FD0006', value: 1 }];
  defconColor(shieldLevel:boolean): String {
    const x = this.colorArray.find((color:any) => color.value === this.defcon);
    return x && (this.bmResetAllowed || shieldLevel) ? '#CEB180' : '#888888';
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.bmResetAllowed))
  bmResetAllowed: string;

  @State((state: RootStoreState) => (state.CoreStoreModule.bmStartTime))
  bmStartTime: number;

  @State((state: RootStoreState) => (state.CoreStoreModule.defcon))
  defcon: number;

  @State((state: RootStoreState) => (state.CoreStoreModule.defconPrecise))
  defconPrecise: number;

  @State((state: RootStoreState) => (state.CoreStoreModule.tenants))
  tenants: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.inEditMode))
  inEditMode: CoreStoreState['inEditMode'];

  @State((state: RootStoreState) => (state.CoreStoreModule.loadDetails))
  loadDetails: CoreStoreState['loadDetails'];

  @State((state: RootStoreState) => (state.CoreStoreModule.selectedTenantId))
  selectedTenantId: string;
  internalSelectedTenantId: string = '';

  @Watch('selectedTenantId')
  updateInternalSelectedTenantId() {
    // this.$nextTick(() => { this.getThirdPartyData(this.selectedTenantId, (this.setTenantId)); });
    this.internalSelectedTenantId = this.selectedTenantId;
  }

  setTenantId() {
    this.$nextTick(() => { this.internalSelectedTenantId = this.selectedTenantId; });
  }

  @Watch('internalSelectedTenantId')
  updateSelectedTenantId() {
    store.commit('setSelectedTenantId', { selectedTenantId: this.internalSelectedTenantId });
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.billmeterloading))
  billmeterloading: number;

  get isBillMeter() {
    return this.currentPath === 'bill-meter';
  }

  get shieldLevel() {
    const shieldLevel = (this.defconPrecise - 1) / 4 * 12;
    return shieldLevel > 0 && shieldLevel < 1 ? 1 : shieldLevel;
  }

  get currentPath() {
    return this.$route.path.split('/')
    .slice(-1)[0];
  }

  get currentNavItem() {
    return navItems.find(x => x.id === this.currentPath);
  }

  get resetTooltip(): TooltipDirValues {
    return {
      content: 'Click to Refresh',
      placement: 'right',
    };
  }

  get tenantTooltip(): TooltipDirValues {
    return {
      content: 'Click to view all Tenants',
      placement: 'right',
    };
  }

  get attachTooltip(): TooltipDirValues {
    return {
      content: 'Rolling 24-hour attack statistics updated every minute',
      placement: 'bottom',
    };
  }

  get clickPopoverValue(): PopoverDirValues {
    return {
      title: this.renderTitle,
      content: this.render1,
      trigger: 'controlled',
      visible: this.isClickPopoverVisible,
      maxWidth: 390,
      maxHeight: 570,
      placement: 'top',
      noPadding: true,
      // onRequestClose: () => {
      //   this.isClickPopoverVisible = false;
      //   this.doNotShow = true;
      // },
      // onClickOutsidePopper: () => { this.isClickPopoverVisible = false; },
    };
  }

  get popoverValue(): PopoverDirValues {
    return {
      withCloseIcon: false,
      content: 'Click to see Dashboard',
      placement: 'left',
    };
  }

  mounted() {
    if (!store.state.CoreStoreModule.inEditMode) {
      const x = document.getElementById('go-back');
      if (x) {
        x.style.display = 'none';
      }
    }
  }

  renderTitle(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div class={['sw-flexbox']}>
        <SwIcon class={['sw-flexbox', 'sw-flexbox--row']} icon id="go-back" name="go-back"
        nativeOn-click={ this.goBack } size="small" color="#47AFE8" style={{ margin:'5px 10px 0 0', cursor:'pointer', display: 'none' }}>
        </SwIcon>
        <span class={[`${this.cssPrefix}__board__title__text`, 'sw-flexbox__flex']}>DEFCON DETAILS</span>
        <span class={[`${this.cssPrefix}__board__title__close`, 'sw-flexbox--end-justify']}
        >
          <sw-icon name="close-thin" size={13} nativeOn-click={this.onClickTrigger}/>
        </span>
      </div>
    ) as VNode;
  }

  render1(h: CreateElement): VNode { // tslint:disable-line
    // const percent = localStorage.getItem('threatsPercent') !== null ? localStorage.getItem('threatsPercent') : '0';
    return (
      <SwFtrRiskMeterPopover></SwFtrRiskMeterPopover>
    ) as VNode;
  }

  onClickTrigger() {
    this.isClickPopoverVisible = !this.isClickPopoverVisible;
    this.doNotShow = !this.doNotShow;
  }
  onClickTriggerStick() {
    this.isClickPopoverVisible = !this.isClickPopoverVisible;
    this.doNotShow = !this.doNotShow;
  }
  @Watch('inEditMode')
  hideBackButton() {
    if (this.inEditMode) {
      const x = document.getElementById('go-back');
      if (x) {
        x.style.display = 'block';
      }
    } else {
      const x = document.getElementById('go-back');
      if (x) {
        x.style.display = 'none';
      }
    }
  }

  goBack() {
    if (store.state.CoreStoreModule.inEditMode) {
      store.commit('setDetailMode', { loadDetails: true });
      const x = document.getElementById('go-back');
      if (x) {
        if (x.style.display === 'block') {
          x.style.display = 'none';
          store.commit('setNavMode', { inEditMode: false });
        } else {
          x.style.display = 'block';
        }
      }
    }
  }
}
